<template>
  <XQuadrant v-if="selected=='quadrant'" />
  <XTaskMap v-if="selected=='map'" />
  <XPomodoro v-if="selected=='Pomodoro'" />
</template>

<script>
	import XQuadrant from '@/components/XQuadrant'
    import XTaskMap from '@/components/XTaskMap';
	import XPomodoro from '@/pages/XPomodoro';

	export default {
		components: {
			XQuadrant,
			XTaskMap,
			XPomodoro
		},
		mounted() {
			this.selected = this.$route.params.item;
		},
		data() {
			return {
				selected: 'quadrant',
			}
		},
		watch: {
			$route() {
				this.selected = this.$route.params.item;
			}
		}
	}
</script>

<style lang="less" scoped>
</style>